import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { WorkOverviewTableComponent } from 'src/app/shared/components/work-overview-table/work-overview-table.component';
import { MainTableComponent } from './main-table/main-table.component';
import { MainTableMobileFiltersComponent } from './main-table/main-table-mobile-filters/main-table-mobile-filters.component';
import { MainTableRotationDialogComponent } from './main-table-rotation-dialog/main-table-rotation-dialog.component';
import { MainTableExpandableRowComponent } from './main-table/main-table-expandable-row/main-table-expandable-row.component';
import { MainTableModuleSpecificTemplateComponent } from './main-table-module-specific-template/main-table-module-specific-template.component';
import { MainTablePaginatorComponent } from './main-table-paginator/main-table-paginator.component';
import { MainTableSearchComponent } from './main-table/main-table-search/main-table-search.component';
import { MaintenanceTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/maintenance-template/maintenance-template.component';
import { MaintenanceTemplatesComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/maintenance-templates.component';
import { AlertTemplateComponent } from './main-table-module-specific-template/table-module-templates/alert-template/alert-template.component';
import { CargoGearTemplateComponent } from './main-table-module-specific-template/table-module-templates/departments-template/cargo-gear-template.component';
import { CargoHoldTemplateComponent } from './main-table-module-specific-template/table-module-templates/departments-template/cargo-hold-template.component';
import { CertificateTemplateComponent } from './main-table-module-specific-template/table-module-templates/certificate-template/certificate-template.component';
import { CompetenceTemplateComponent } from './main-table-module-specific-template/table-module-templates/competence-template/competence-template.component';
import { ComponentHistoryTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/component-history-template/component-history-template.component';
import { ContactPersonTemplateComponent } from './main-table-module-specific-template/table-module-templates/departments-template/contact-person-template.component';
import { ContactsTemplateComponent } from './main-table-module-specific-template/table-module-templates/tenant-template/contacts-template.component';
import { CrewManagementTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-template/crew-management-template.component';
import { CrewManagementUserTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/crew-management-user-template.component';
import { CrewManagementUserTemplatesComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/crew-management-user-templates.component';
import { DepartmentsTemplateComponent } from './main-table-module-specific-template/table-module-templates/departments-template/departments-template.component';
import { DepartmentsTemplatesComponent } from './main-table-module-specific-template/table-module-templates/departments-template/departments-templates.component';
import { DocumentOverviewTemplateComponent } from './main-table-module-specific-template/table-module-templates/document-template/document-overview-template.component';
import { DocumentReadReceiptRequestsTemplateComponent } from './main-table-module-specific-template/table-module-templates/document-template/document-read-receipt-requests-template.component';
import { DocumentTemplatesComponent } from './main-table-module-specific-template/table-module-templates/document-template/document-templates.component';
import { DrillsLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/drills-template/drills-log-template.component';
import { DrillsOverviewTemplateComponent } from './main-table-module-specific-template/table-module-templates/drills-template/drills-overview-template.component';
import { DrillsTemplatesComponent } from './main-table-module-specific-template/table-module-templates/drills-template/drills-templates.component';
import { DueListTemplateComponent } from './main-table-module-specific-template/table-module-templates/due-list-template/due-list-template.component';
import { EngineTemplateComponent } from './main-table-module-specific-template/table-module-templates/departments-template/engine-template.component';
import { FormsLibraryTemplateComponent } from './main-table-module-specific-template/table-module-templates/forms-library-template/forms-library-template.component';
import { MedicineTemplateComponent } from './main-table-module-specific-template/table-module-templates/medicine-template/medicine-template.component';
import { MessageTemplateComponent } from './main-table-module-specific-template/table-module-templates/message-template/message-template.component';
import { NonConformanceTemplateComponent } from './main-table-module-specific-template/table-module-templates/non-conformance-template/non-conformance-template.component';
import { PermitToWorkTemplateComponent } from './main-table-module-specific-template/table-module-templates/permit-to-work-template/permit-to-work-template.component';
import { OrderAdminTemplateComponent } from './main-table-module-specific-template/table-module-templates/order-admin-template/order-admin-template.component';
import { OrderUserTemplateComponent } from './main-table-module-specific-template/table-module-templates/order-user-template/order-user-template.component';
import { PaxOnBoardTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/pax-on-board-template.component';
import { PaxTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/pax-template.component';
import { PlannedActivityUserTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/planned-activity-user-template.component';
import { ProfileCompetenceTemplateComponent } from './main-table-module-specific-template/table-module-templates/profile-template/profile-competence-template.component';
import { UserActivitiesTripsTemplateComponent } from './main-table-module-specific-template/table-module-templates/profile-template/user-activities-trips-template.component';
import { ReadReceiptTemplateComponent } from './main-table-module-specific-template/table-module-templates/read-receipt-template/read-receipt-template.component';
import { RuntimeTemplateComponent } from './main-table-module-specific-template/table-module-templates/runtime-template/runtime-template.component';
import { StorageTemplateComponent } from './main-table-module-specific-template/table-module-templates/storage-template/storage-template.component';
import { TaskLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/task-template/task-log-template.component';
import { TaskOverviewTemplateComponent } from './main-table-module-specific-template/table-module-templates/task-template/task-overview-template.component';
import { TaskTemplatesComponent } from './main-table-module-specific-template/table-module-templates/task-template/task-template.component';
import { TenantTemplatesComponent } from './main-table-module-specific-template/table-module-templates/tenant-template/tenant-templates.component';
import { UsersTemplateComponent } from './main-table-module-specific-template/table-module-templates/users-template/users-template.component';
import { DefaultCellComponent } from './main-table-module-specific-template/table-module-templates/default-cell.component';
import { MaterialModule } from '../../modules/material.module';
import { IsArrayPipe } from '../pipes/is-array.pipe';
import { ShouldHeaderBeDisplayedPipe } from '../pipes/should-header-be-displayed.pipe';
import { MapProductActionPipe } from '../pipes/map-product-action.pipe';
import { MapNonConformanceActionPipe } from '../pipes/map-non-conformance-action.pipe';
import { MapMedicineEventPipe } from '../pipes/map-medicine-event.pipe';
import { IsStringArrayPipe } from '../pipes/is-string-array.pipe';
import { OnBoardStatusMapPipe } from '../pipes/on-board-status-map.pipe';
import { DateDiffPipe } from '../pipes/date-diff.pipe';
import { SplitPipe } from '../pipes/split-text.pipe';
import { DaysBeforeExpiredPipe } from '../pipes/days-before-expired.pipe';
import { PassArgumentsToObjectsFunctionsPipe } from '../pipes/pass-arguments-to-objects-functions.pipe';
import { UIElementsModule } from '../ui-elements/ui-elements.module';
import { AppLoaderDirective } from '../directives/app-loader.directive';
import { AppStopClickPropagationDirective } from '../directives/stop-click-propagation.directive';
import { ResizeDirective } from '../directives/resize.directive';
import { FitToViewportDirective } from '../directives/fit-to-viewport.directive';
import { IsSingleLevelPlacementPipe } from '../pipes/is-single-level-placement.pipe';
import { ProfileTemplatesComponent } from './main-table-module-specific-template/table-module-templates/profile-template/profile-templates.component';
import { ContainsPipe } from '../../core/pipes/contains.pipe';
import { MapProcurementAreaPipe } from '../pipes/map-procurement-area.pipe';
import { DelimitedCurrencyPipe } from '../pipes/delimited-currency.pipe';
import { EquivalentCompetencesTooltipComponent } from '../components/equivalent-competences-tooltip/equivalent-competences-tooltip.component';
import { DocumentRevisionsTemplateComponent } from './main-table-module-specific-template/table-module-templates/document-template/document-revisions-template.component';
import { ProductOwnerUsersTemplateComponent } from './main-table-module-specific-template/table-module-templates/product-owner-users-template/product-owner-users-template.component';
import { RiskAssessmentsTemplateComponent } from './main-table-module-specific-template/table-module-templates/risk-assessments-template/risk-assessments-template.component';
import { MapRiskAssessmentActionPipe } from '../pipes/map-risk-assessment-action.pipe';
import { DocumentStatusMapPipe } from '../pipes/document-status-map.pipe';
import { PrivilegeTemplatesTemplateComponent } from './main-table-module-specific-template/table-module-templates/privilege-template/privilege-templates-template.component';
import { MainTableColumnFilterComponent } from './main-table/main-table-column-filter/main-table-column-filter.component';
import { TripsTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/trips-template.component';
import { TripUserStatusPipe } from '../pipes/trip-user-status.pipe';
import { TextOverflowLabelComponent } from './main-table-module-specific-template/table-module-templates/cells/text-overflow-label/text-overflow-label.component';
import { LogChangeBreakdownComponent } from './main-table-module-specific-template/table-module-templates/cells/log-change-breakdown/log-change-breakdown.component';
import { PositionsCellComponent } from './main-table-module-specific-template/table-module-templates/cells/positions-cell/positions-cell.component';
import { QuantityTypesTemplateComponent } from './main-table-module-specific-template/table-module-templates/quantity-types-template/quantity-types-template.component';
import { ConfirmDialogDirective } from '../dialogs/confirm-dialog/confirm-dialog.directive';
import { PerformJobSparePartsTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/perform-job-spare-parts-template/perform-job-spare-parts-template.component';
import { FullNamePipe } from '../pipes/full-name.pipe';
import { TripCrewMembersTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/trip-crew-members-template.component';
import { TripPaxesTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/trip-paxes-template.component';
import { StandardJobTemplatesTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/standard-job-templates-template/standard-job-templates-template.component';
import { ExportErrorsTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/export-errors-template/export-errors-template.component';
import { MarineManagerIssuesTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/marine-manager-issues-template/marine-manager-issues-template.component';
import { MaintenanceJobLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/maintenance-job-log-template/maintenance-job-log-template.component';
import { ProjectsTemplateComponent } from './main-table-module-specific-template/table-module-templates/maintenance-templates/projects-template/projects-template.component';
import { DepartmentPauseLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/departments-template/department-pause-log-template/department-pause-log-template.component';
import { GenericLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/generic-log-template/generic-log-template.component';
import { PlannedActivityAdminLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/planned-activity-admin-log-template.component';
import { CertificateTemplatesComponent } from './main-table-module-specific-template/table-module-templates/certificate-template/certificate-templates.component';
import { ChemicalExposureLogTemplateComponent } from './main-table-module-specific-template/table-module-templates/chemical-exposure-log-template/chemical-exposure-log-template.component';
import { ActionInProgressPipe } from '../directives/action-in-progress.pipe';
import { WorkAndRestTemplateComponent } from './main-table-module-specific-template/table-module-templates/work-and-rest-template/work-and-rest-template.component';
import { WorkAndRestUserTemplateComponent } from './main-table-module-specific-template/table-module-templates/crew-management-user-template/work-and-rest-user-template/work-and-rest-user-template.component';
import { WorkAndRestSignOffTemplateComponent } from './main-table-module-specific-template/table-module-templates/work-and-rest-templates/work-and-rest-sign-off-template/work-and-rest-sign-off-template.component';
import { WorkAndRestTemplatesComponent } from './main-table-module-specific-template/table-module-templates/work-and-rest-templates/work-and-rest-templates.component';
import { WorkAndRestWorkApprovalTemplateComponent } from './main-table-module-specific-template/table-module-templates/work-and-rest-templates/work-and-rest-work-approval-template/work-and-rest-work-approval-template.component';
import { WorkPlanValidationTemplateComponent } from './main-table-module-specific-template/table-module-templates/work-and-rest-templates/workplan-validation-template/work-plan-validation-template.component';
import { ParseHttpsLinksPipe } from '../pipes/parse-https-links.pipe';
import { TimeDisplayPipe } from '../../core/pipes/time-display.pipe';
import { NumberRoundPipe } from '../../core/pipes/number-round.pipe';
import { DialogContainerComponent } from '../dialogs/dialog-container/dialog-container.component';

@NgModule({
  declarations: [
    AlertTemplateComponent,
    CargoGearTemplateComponent,
    CargoHoldTemplateComponent,
    CertificateTemplateComponent,
    GenericLogTemplateComponent,
    PlannedActivityAdminLogTemplateComponent,
    CompetenceTemplateComponent,
    ComponentHistoryTemplateComponent,
    ContactPersonTemplateComponent,
    ContactsTemplateComponent,
    CrewManagementTemplateComponent,
    CrewManagementUserTemplateComponent,
    CrewManagementUserTemplatesComponent,
    DefaultCellComponent,
    DepartmentPauseLogTemplateComponent,
    DepartmentsTemplateComponent,
    DepartmentsTemplatesComponent,
    CertificateTemplatesComponent,
    ChemicalExposureLogTemplateComponent,
    DocumentOverviewTemplateComponent,
    DocumentReadReceiptRequestsTemplateComponent,
    DocumentRevisionsTemplateComponent,
    DocumentTemplatesComponent,
    DrillsLogTemplateComponent,
    DrillsOverviewTemplateComponent,
    DrillsTemplatesComponent,
    DueListTemplateComponent,
    EngineTemplateComponent,
    FormsLibraryTemplateComponent,
    LogChangeBreakdownComponent,
    MainTableComponent,
    MainTableMobileFiltersComponent,
    MainTableExpandableRowComponent,
    MainTableColumnFilterComponent,
    MainTableModuleSpecificTemplateComponent,
    MainTablePaginatorComponent,
    MainTableRotationDialogComponent,
    MainTableSearchComponent,
    MaintenanceTemplateComponent,
    MaintenanceJobLogTemplateComponent,
    MaintenanceTemplatesComponent,
    MapProcurementAreaPipe,
    MedicineTemplateComponent,
    MessageTemplateComponent,
    NonConformanceTemplateComponent,
    PermitToWorkTemplateComponent,
    OrderAdminTemplateComponent,
    OrderUserTemplateComponent,
    PaxOnBoardTemplateComponent,
    PaxTemplateComponent,
    PlannedActivityUserTemplateComponent,
    ProductOwnerUsersTemplateComponent,
    ProfileCompetenceTemplateComponent,
    ProfileTemplatesComponent,
    PrivilegeTemplatesTemplateComponent,
    PositionsCellComponent,
    RiskAssessmentsTemplateComponent,
    ReadReceiptTemplateComponent,
    RuntimeTemplateComponent,
    StorageTemplateComponent,
    TaskLogTemplateComponent,
    TaskOverviewTemplateComponent,
    TaskTemplatesComponent,
    TenantTemplatesComponent,
    TripCrewMembersTemplateComponent,
    TripPaxesTemplateComponent,
    UserActivitiesTripsTemplateComponent,
    UsersTemplateComponent,
    TripsTemplateComponent,
    QuantityTypesTemplateComponent,
    ExportErrorsTemplateComponent,
    MarineManagerIssuesTemplateComponent,
    PerformJobSparePartsTemplateComponent,
    ProjectsTemplateComponent,
    StandardJobTemplatesTemplateComponent,
    WorkAndRestTemplateComponent,
    WorkAndRestUserTemplateComponent,
    WorkAndRestSignOffTemplateComponent,
    WorkAndRestTemplatesComponent,
    WorkAndRestWorkApprovalTemplateComponent,
    WorkPlanValidationTemplateComponent,
  ],
  exports: [
    MainTableComponent,
    MainTablePaginatorComponent,
    MainTableColumnFilterComponent,
    MainTableSearchComponent,
    FitToViewportDirective,
  ],
  imports: [
    ActionInProgressPipe,
    AppLoaderDirective,
    AppStopClickPropagationDirective,
    CommonModule,
    ConfirmDialogDirective,
    ContainsPipe,
    DateDiffPipe,
    DaysBeforeExpiredPipe,
    DelimitedCurrencyPipe,
    DialogContainerComponent,
    DocumentStatusMapPipe,
    EquivalentCompetencesTooltipComponent,
    FitToViewportDirective,
    IsArrayPipe,
    IsSingleLevelPlacementPipe,
    IsStringArrayPipe,
    FullNamePipe,
    MapMedicineEventPipe,
    MapNonConformanceActionPipe,
    MapProductActionPipe,
    MapRiskAssessmentActionPipe,
    MaterialModule,
    OnBoardStatusMapPipe,
    PassArgumentsToObjectsFunctionsPipe,
    ParseHttpsLinksPipe,
    ResizeDirective,
    RouterModule,
    ShouldHeaderBeDisplayedPipe,
    SplitPipe,
    TextOverflowLabelComponent,
    TimeDisplayPipe,
    NumberRoundPipe,
    TranslateModule,
    TripUserStatusPipe,
    UIElementsModule,
    WorkOverviewTableComponent,
  ],
  providers: [CurrencyPipe],
})
export class MainTableModule {}
